import { IDotXetHocVuPhamViActionTypes } from "../../action-types/xet-hoc-vu/IDotXetHocVuPhamViActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IDotXetHocVuPhamViReducer } from "../../reducer-model/xet-hoc-vu/IDotXetHocVuPhamViReducer";

const iniState: IDotXetHocVuPhamViReducer = {
    status: eReducerStatusBase.is_not_initialization,
    dotXetHocVuPhamVis: [],
    dotXetHocVuIdAdd: 0,
}

export const dotXetHocVuPhamViReducer = (state: IDotXetHocVuPhamViReducer = iniState, action: IDotXetHocVuPhamViActionTypes): IDotXetHocVuPhamViReducer => {
    switch (action.type) {
        case "DOT_XET_HOC_VU_PHAM_VI_LOAD_BY_DOT_XET_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            };
        case "DOT_XET_HOC_VU_PHAM_VI_LOAD_BY_DOT_XET_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                dotXetHocVuPhamVis: action.payload
            };
        case "DOT_XET_HOC_VU_PHAM_VI_LOAD_BY_DOT_XET_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "DOT_XET_HOC_VU_PHAM_VI_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "DOT_XET_HOC_VU_PHAM_VI_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                 isShowAddModal: false,
            };
        case "DOT_XET_HOC_VU_PHAM_VI_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "DOT_XET_HOC_VU_PHAM_VI_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "DOT_XET_HOC_VU_PHAM_VI_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
               
            };
        case "DOT_XET_HOC_VU_PHAM_VI_SHOW_ADD_MODAL":
            return {
                ...state,
                isShowAddModal: true,
                dotXetHocVuIdAdd: action.payload,
            };
        case "DOT_XET_HOC_VU_PHAM_VI_CLOSE_ADD_MODAL":
            return {
                ...state,
                isShowAddModal: false,
                dotXetHocVuIdAdd: 0,
            };
        default:
            return state;
    }
}